import React, { useState } from 'react';
import ReactModal from 'react-modal';

import * as S from './styles';
import { ModalStyles } from './styles';

import { Button } from '../../micros/Button';
import { Icon } from '../../micros/Icon';
import { MediaMatch } from '../../micros/MediaMatch';
import { ShortcutButton } from '../../micros/ShortcutButton';
import appleImg from '../../../assets/img/apple-store.svg';
import googleImg from '../../../assets/img/play-store.svg';

import { ShortcutHomeProps, apps, ShortcutButtonData } from './types';

const ShortcutHome = ({
	title = 'Título desktop',
	titleMobile = 'Título mobile',
	darkMode = false,
	shortcutButtons,
}: ShortcutHomeProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [indexModal, setIndexModal] = useState(0);

	const handleClickButton = (shortcut: ShortcutButtonData, index: number) => {
		if (shortcut.isModal) {
			setIndexModal(index);
			setIsOpen(true);
			return;
		}
		const isBlank = shortcut.externalLink ? '_blank' : '_self';
		window.open(shortcut.url, isBlank);
	};

	const handleClickModal = (url: string, target: boolean) => {
		const isBlank = target ? '_blank' : '_self';
		window.open(url, isBlank);
	};

	const renderIcon = (icon: string) => (
		<Icon icon={icon} size="large" color="portoSeguros100" />
	);

	return (
		<S.Section as="section">
			<S.Container>
				<MediaMatch lessThan="tabletPortrait">
					<S.Title tabIndex={0} darkMode={darkMode}>
						{titleMobile}
					</S.Title>
				</MediaMatch>
				<MediaMatch greaterThan="tabletPortrait">
					<S.Title tabIndex={0} darkMode={darkMode}>
						{title}
					</S.Title>
				</MediaMatch>
				<S.List as="ul">
					{shortcutButtons?.length > 0 &&
						shortcutButtons.map((shortCut, index) => (
							<S.Item
								as="li"
								key={shortCut.label}
								colMobile={4}
								colPortrait={2}
								colLandscape={2}
								colDesktop={2}
								colUltraWide={2}
							>
								<ShortcutButton
									textTag="h3"
									onClick={() => handleClickButton(shortCut, index)}
									variant={darkMode ? 'defaultStroke' : shortCut.variant}
									icon={shortCut.icon}
									gtmName={title}
									text={shortCut.label}
									isLink={shortCut.isLink}
								/>
							</S.Item>
						))}
				</S.List>
				<ReactModal
					style={{
						overlay: ModalStyles.overlay,
						content: ModalStyles.content,
					}}
					isOpen={isOpen}
					onRequestClose={() => setIsOpen(false)}
					ariaHideApp={false}
				>
					{shortcutButtons?.length > 0 && (
						<S.ModalContent darkMode={darkMode} data-testid="shortcut-modal">
							<Icon
								icon={shortcutButtons[indexModal].iconModal!}
								size="xhuge"
								color="portoSeguros100"
							/>
							<S.Text>{shortcutButtons[indexModal].textModal}</S.Text>
							{shortcutButtons[indexModal].flagAction === 'apps' && (
								<>
									<S.SubText>
										{shortcutButtons[indexModal].subTextModal}
									</S.SubText>
									<S.Box style={{ flexDirection: 'row' }}>
										<a
											target="_blank"
											rel="noreferrer"
											href={apps['apple-store'].url}
										>
											<img
												loading="lazy"
												alt={apps['apple-store'].alt}
												src={appleImg}
											/>
										</a>
										<a
											target="_blank"
											rel="noreferrer"
											href={apps['play-store'].url}
										>
											<img
												loading="lazy"
												alt={apps['play-store'].alt}
												src={googleImg}
											/>
										</a>
									</S.Box>
								</>
							)}
							{shortcutButtons[indexModal].flagAction === 'buttons' && (
								<>
									<S.Box>
										<Button
											fullWidth
											variant="insurance"
											iconSide="left"
											styles="secondary"
											onClick={() =>
												handleClickModal(
													shortcutButtons[indexModal].urlOne!,
													shortcutButtons[indexModal].externalLinkOne!
												)
											}
											icon={renderIcon(shortcutButtons[indexModal].iconOne!)}
										>
											{shortcutButtons[indexModal].labelOne}
										</Button>
										<Button
											fullWidth
											variant="insurance"
											iconSide="left"
											styles="secondary"
											onClick={() =>
												handleClickModal(
													shortcutButtons[indexModal].urlTwo!,
													shortcutButtons[indexModal].externalLinkTwo!
												)
											}
											icon={renderIcon(shortcutButtons[indexModal].iconTwo!)}
										>
											{shortcutButtons[indexModal].labelTwo}
										</Button>
									</S.Box>
								</>
							)}
							<S.Exit
								tabIndex={0}
								aria-label="Sair do modal."
								onClick={() => setIsOpen(false)}
								data-testid="shortcut-modal-exit"
							>
								<Icon
									icon="icon-porto-ic-close"
									size="large"
									color="portoSeguros100"
								/>
							</S.Exit>
						</S.ModalContent>
					)}
				</ReactModal>
			</S.Container>
		</S.Section>
	);
};
export default ShortcutHome;
